import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

export const useScreenOperation = () => {
  const scrollToErrorPosition = () => {
    const errors = document.getElementsByClassName('v-input--error')
    const clientRect = errors[0].getBoundingClientRect()
    const py = window.pageYOffset + clientRect.top
    window.scrollTo({
      top: py - 100,
      left: 0,
      behavior: "smooth"
    });
  }
  const toTopIfNameNotEntered = () => {
    const store = useStore()
    const router = useRouter()
    const jwt = store.state.apiParams.jwtToken
    const treatmentConsultationSeq = store.state.apiParams.treatmentConsultationSeq
    const treatmentSerialNumber = store.state.apiParams.treatmentSerialNumber

    if (store.state.advanceInterview.name === '') {
      router.push('/interview?bearertoken=' + jwt + 'treatmentConsultationSeq=' + treatmentConsultationSeq + 'treatmentSerialNumber=' + treatmentSerialNumber)
    }
  }
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  }
  const fromConfirmScreen = () => {
    const route = useRoute()
    return (route.query.from !== undefined && route.query.from === 'confirm')
  }
  const toErrorIfNotExistsId = async () => {
    const store = useStore()
    const router = useRouter()
    const treatmentConsultationSeq = store.getters['apiParams/treatmentConsultationSeq']
    const treatmentSerialNumber = store.getters['apiParams/treatmentSerialNumber']


    if (treatmentConsultationSeq == '' || treatmentSerialNumber == '') {
      router.push('/error')
    }
  }
  return {
    scrollToErrorPosition,
    scrollToTop,
    fromConfirmScreen,
    toTopIfNameNotEntered,
    toErrorIfNotExistsId
  }
}
